"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LanguageSpanishOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LanguageSpanishOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.876 10.296c.165-.25.248-.544.248-.88 0-.299-.056-.55-.168-.752a1.606 1.606 0 0 0-.48-.528 4.5 4.5 0 0 0-.744-.432c-.24-.117-.44-.219-.6-.304a1.283 1.283 0 0 1-.36-.264.52.52 0 0 1-.12-.344c0-.117.027-.219.08-.304a.582.582 0 0 1 .248-.2.931.931 0 0 1 .384-.072c.218 0 .432.03.64.088.208.059.443.141.704.248l.392-.944a5.566 5.566 0 0 0-.848-.296 3.359 3.359 0 0 0-.848-.104c-.395 0-.739.064-1.032.192a1.514 1.514 0 0 0-.672.56c-.155.24-.232.53-.232.872 0 .261.045.485.136.672.09.187.205.347.344.48.144.128.293.237.448.328.155.085.299.16.432.224.213.101.402.197.568.288.165.085.296.179.392.28a.501.501 0 0 1 .152.368c0 .117-.03.221-.088.312a.545.545 0 0 1-.264.216c-.117.053-.275.08-.472.08-.288 0-.579-.048-.872-.144-.288-.101-.568-.21-.84-.328v1.128c.155.075.317.139.488.192a4.235 4.235 0 0 0 1.128.152c.448 0 .827-.067 1.136-.2.314-.139.554-.333.72-.584ZM4.28 11h3.287v-1h-2.08V8.528h1.936v-.992H5.487V6.28h2.08v-.992H4.28V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LanguageSpanishOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LanguageSpanishOutline;
exports["default"] = _default;